import axios from "@/plugins/axios";

export default {
  namespaced: true,

  state: {
    equipments: [],
    discoveredEquipments: [],
  },
  mutations: {
    SET_EQUIPMENTS(state, value) {
      state.equipments = value
    },
    SET_DISCOVERED_EQUIPMENTS(state, value) {
      state.discoveredEquipments = value
    },
  },
  getters: {
    getEquipments(state) {
      return state.equipments
    },
    getDiscoveredEquipments(state) {
      return state.discoveredEquipments
    },
  },
  actions: {
    async getAllEquipments({ commit }) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.get('/equipments').then(res => {
          commit('SET_EQUIPMENTS', res.data)
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async getDiscoveredEquipments({ commit }) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.get('/equipments/discovered').then(res => {
          commit('SET_DISCOVERED_EQUIPMENTS', res.data)
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async updateEquipment(_, data) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.put('/equipments', data).then(res => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async createEquipment(_, data) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.post('/equipments', data).then(res => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async updateHighCurrents(_, data) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.post('/equipments/mqtt/high_currents', data).then(res => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async deleteEquipment(_, data) {
      return new Promise((resolve, reject) => {
        axios.axiosApiInstance.delete('/equipments/' + data._id).then(res => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
  },
}
